import { render, staticRenderFns } from "./LandingPageCard.vue?vue&type=template&id=2037022a&scoped=true"
import script from "./LandingPageCard.vue?vue&type=script&lang=js"
export * from "./LandingPageCard.vue?vue&type=script&lang=js"
import style0 from "./LandingPageCard.vue?vue&type=style&index=0&id=2037022a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2037022a",
  null
  
)

export default component.exports